import { useQuery } from '@tanstack/react-query';
import { Grid } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { NavListContext, useThrottledHandler } from 'App';
import img from 'app/img';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import termsApi, { TermsNodeListDT } from 'services/apis/cnt2/term-api';

const TermList = (data: { termTaxonomy: string }) => {
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState<boolean>(true);
  const navList = useContext(NavListContext).navList;
  const termId = navList.top2TermNow?.termUuid || navList.top1TermNow?.termUuid || navList.btmTermNow?.termUuid;
  const fetchTermList = async () => {
    const result = await termsApi.treeTerm({ parentTermId: termId, termTaxonomy: data.termTaxonomy }, {});
    if (result.code === 0 && result.successful) {
      return result.result;
    }
  };

  const fetchTermListQuery = useQuery({
    queryKey: ['fetchTermList', { parentTermId: termId, termTaxonomy: data.termTaxonomy }],
    queryFn: () => {
      return fetchTermList();
    },
  });

  if (fetchTermListQuery?.data?.termsNodeList.length === 0) {
    return <></>;
  } else
    return (
      <>
        <div className=" m-2 flex justify-between text-base bg-gradient-to-r from-orange-400/80 to-violet-400/30 text-slate-100 rounded-md shadow-md pt-1.5 px-2">
          <div className="pb-1">{data.termTaxonomy === 'topics' ? '热门专题' : '热门标签'}</div>
          {true && (
            <div
              onClick={() => {
                setCollapse(!collapse);
              }}
            >
              {collapse ? (
                <div className=" flex mb-1">
                  <div>展开</div>
                  <AiOutlineDown size={22} />
                </div>
              ) : (
                <div className=" flex mb-1">
                  <div>折叠</div>
                  <AiOutlineUp size={22} />
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className={[
            data.termTaxonomy === 'topics' ? 'min-h-20' : 'min-h-24',
            ' rounded-md shadow-md mx-2 p-1 bg-gradient-to-br from-purple-100 to-orange-200 ',
            collapse ? (data.termTaxonomy === 'topics' ? 'h-20' : 'h-24') : 'h-full',
          ].join(' ')}
        >
          {data.termTaxonomy === 'topics' ? (
            <>
              <Grid
                columns={4}
                className=" flex flex-wrap overflow-y-auto h-full"
              >
                {fetchTermListQuery?.data?.termsNodeList?.map((item) => (
                  <GridItem
                    className=" grow rounded-md shadow-xl m-1 px-2 bg-gradient-to-br from-orange-400 to-orange-300/60 text-white h-16 content-center text-sm "
                    onClick={() => {
                      navigate('/term', {
                        state: { term: item, termTaxonomy: 'topics' },
                      });
                    }}
                  >
                    {item.termName}
                  </GridItem>
                ))}
              </Grid>
            </>
          ) : (
            <>
              <div className=" flex flex-wrap overflow-y-auto h-full max-h-96">
                {fetchTermListQuery?.data?.termsNodeList?.map((item) => (
                  <div
                    className=" grow rounded-md h-9 shadow-xl m-1 px-2 bg-gradient-to-br from-orange-400 to-orange-300 text-white content-center text-sm"
                    onClick={() => {
                      navigate('/term', {
                        state: { term: item, termTaxonomy: 'tag' },
                      });
                    }}
                  >
                    {item.termName}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </>
    );
};
export default TermList;
